import { render, staticRenderFns } from "./InfoStudentRegisterSubject.vue?vue&type=template&id=c98c1da8&"
import script from "./InfoStudentRegisterSubject.vue?vue&type=script&lang=js&"
export * from "./InfoStudentRegisterSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports